const ScrollTriggerHome = () => {
  ScrollTrigger.defaults({
    markers: false,
  });

  const content = document.querySelector('main');

  const desktopLarge = () => {
    let logo = gsap.utils.toArray('.nav-main .midnightHeader .logo-holder'),
      menu = gsap.utils.toArray('.nav-main .midnightHeader .nav-wrapper');

    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: content,
        start: '-75px 70%',
        end: () => '+=' + window.innerHeight / 2,
        id: 'logo',
        toggleActions: 'restart pause reverse pause',
        scrub: 1,
      },
    });

    tl.fromTo(
      logo, {
        width: '100%',
        transformOrigin: '0 100%',
      }, {
        width: '65%',
        ease: 'power2.out',
      }
    );
    tl.fromTo(
      menu, {
        width: '100%',
        transformOrigin: '0 50%',
      }, {
        width: '65%',
        ease: 'power2.out',
      },
      '<'
    );
  };

  const desktopMedium = () => {
    let logo = gsap.utils.toArray('.nav-main .midnightHeader .logo-holder'),
      menu = gsap.utils.toArray('.nav-main .midnightHeader .nav-wrapper');

    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: content,
        start: '-75px 70%',
        end: () => '+=' + window.innerHeight / 2,
        id: 'logo',
        toggleActions: 'restart pause reverse pause',
        scrub: 1,
      },
    });

    tl.fromTo(
      logo, {
        width: '100%',
        transformOrigin: '0 100%',
      }, {
        width: '75%',
        ease: 'power2.out',
      }
    );
    tl.fromTo(
      menu, {
        width: '100%',
        transformOrigin: '0 50%',
      }, {
        width: '75%',
        ease: 'power2.out',
      },
      '<'
    );
  };

  const logoMobilePortrait = () => {
    let holder = gsap.utils.toArray('.nav-mobile .logo-holder');

    if (holder) {
      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: content,
          start: '-75px 60%',
          end: () => '+=' + window.innerHeight / 2,
          id: 'logoMobilePortrait',
          toggleActions: 'restart pause reverse pause',
          scrub: 0.5,
        },
      });

      tl.fromTo(
        holder, {
          width: '100%',
          transformOrigin: '0 0',
          marginTop: '20%',
        }, {
          marginTop: '10px',
          width: '33.5%',
          ease: 'power2.out',
        },
        '<'
      );
    }
  };

  const logoMobileLandscape = () => {
    let holder = gsap.utils.toArray('.nav-mobile .logo-holder');

    let tween = gsap.fromTo(
      holder, {
        width: '100%',
        transformOrigin: '0 0',
      }, {
        width: '60%',
        ease: 'power2.out',
      }
    );

    gsap.set(holder, {
      marginTop: '10px',
    });

    ScrollTrigger.create({
      trigger: content,
      animation: tween,
      start: '-75px 60%',
      end: () => '+=' + window.innerHeight / 2,
      id: 'LogoMobileLandscape',
      toggleActions: 'restart pause reverse pause',
      scrub: 0.5,
    });
  };

  const bottomBorder = () => {
    let bottomBorder = document.querySelector(
      '.window-border .bottom-border');

    let tween = gsap.fromTo(
      bottomBorder, {
        autoAlpha: 0,
      }, {
        autoAlpha: 1,
        ease: 'none',
      }
    );

    ScrollTrigger.create({
      trigger: content,
      animation: tween,
      start: 'top bottom',
      end: '+=15',
      id: 'bottom-border',
      toggleActions: 'restart pause reverse pause',
      scrub: 0.25,
    });
  };

  const topBorder = () => {
    let topBorder = document.querySelector('.window-border .top-border');

    let tween = gsap.fromTo(
      topBorder, {
        autoAlpha: 0,
      }, {
        autoAlpha: 1,
        ease: 'none',
      }
    );

    ScrollTrigger.create({
      trigger: content,
      animation: tween,
      start: 'top top',
      end: '+=15',
      id: 'top-border',
      toggleActions: 'restart pause reverse pause',
      scrub: 0.25,
    });
  };

  ScrollTrigger.matchMedia({
    // desktop
    '(min-width: 1280px)': function () {
      desktopLarge();
    },

    // desktop
    '(min-width: 1024px) and (max-width: 1279px)': function () {
      desktopMedium();
    },

    // mobile/tablet portrait
    '(max-width: 1023px) and (orientation: portrait)': function () {
      logoMobilePortrait();
    },

    // mobile/tablet landscape
    '(max-width: 1023px) and (orientation: landscape)': function () {
      logoMobileLandscape();
    },

    // all
    all: function () {
      bottomBorder();
      topBorder();
    },
  });
};

const CreateBatch = (target) => {
  gsap.defaults({
    ease: 'power2.out',
    duration: 1,
  });
  gsap.set(target, {
    y: 100,
    autoAlpha: 0,
  });

  ScrollTrigger.batch(target, {
    //interval: 0.2, // time window (in seconds) for batching to occur.
    //batchMax: 12, // maximum batch size (targets). Can be function-based for dynamic values
    onEnter: (batch) =>
      gsap.to(batch, {
        autoAlpha: 1,
        y: 0,
        stagger: 0.15,
        overwrite: true,
        onComplete: function () {
          this.targets().forEach((elem) => elem.classList.add(
            'active'));
        },
      }),
    onLeave: (batch) =>
      gsap.to(batch, {
        autoAlpha: 0,
        y: -100,
        overwrite: true,
      }),
    onEnterBack: (batch) =>
      gsap.to(batch, {
        autoAlpha: 1,
        y: 0,
        stagger: 0.15,
        overwrite: true,
      }),
    onLeaveBack: (batch) =>
      gsap.to(batch, {
        autoAlpha: 0,
        y: 100,
        overwrite: true,
      }),
    // you can also define most normal ScrollTrigger values like start, end, etc.
    start: '10% bottom',
    end: '90% top',
    //markers: true,
  });
};

export {
  ScrollTriggerHome,
  CreateBatch
};
